export default __webpack_public_path__ + "static/screenSecondSectionRuBig-0f0806e466c7fe1c6ec4df3de19f8327.webp";